module.exports = __webpack_public_path__ + "static/img/logo_y.c5a9eb4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_y.gif
// module id = 7sDC
// module chunks = 1